import React from "react";
import { ImageLoader, TitleLoader } from "./LoaderCommon";

export default function AgenciesLoader() {
    return (
        <div className="agencies-card-inner">
            <div className="card_img agy_card_img">
                <ImageLoader />
            </div>
            <div className="agent_card_content">
                <h2 className="agent-name">
                    <TitleLoader />
                </h2>
                <div className="agent_property_name">
                    <TitleLoader />
                </div>
                <div className="agent_area">
                    <TitleLoader />
                </div>
            </div>
        </div>
    );
}
